module.exports = __webpack_public_path__ + "img/survey-mpp.fbe7d86b.png";